import React, { useEffect, useRef } from "react";
import {useDispatch, useSelector} from "react-redux";
import GroupsContainer from "../GroupsContainer/GroupsContainer";
import styles from "./MenuContainer.module.scss";
import FacetsContainer from "../FacetsContainer/FacetsContainer";
import MiddlefacetsContainer from "../MiddlefacetsContainer/MiddlefacetsContainer";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import SubmitFilterButtonContainer from "../SubmitFilterButtonContainer";
import {HIDE_MENU} from "../../Store/Actions/ActionTypes";

const MenuContainer = (props) => {
    const ref = useRef(null);
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    const isMobile = newFilterState.isMobile;


    useEffect(() => {
        document.addEventListener("click",clickOutsideHandler);

        return () => {
            document.removeEventListener("click",clickOutsideHandler);
        }
    });
    const mainFacetIDs = [ // Hack to filter out clicking main facets, needs to be updated if name change / new facets
        "mainfacet-utdanninger",
        "mainfacet-annet_innhold",
        "mainfacet-laerested",
        "mainfacet-artikler",
        "mainfacet-yrker"
    ]
    const clickOutsideHandler = (e) => {
        if (
            !(ref.current && ref.current.contains(e.target))
            && !e.target.classList.contains("innhold")
            && (
                e.target.parentElement
                && mainFacetIDs.indexOf(e.target.parentElement.id) < 0
            )
            && mainFacetIDs.indexOf(e.target.id) < 0
        ) {
            dispatch({type:HIDE_MENU});
        }
    };


    return (
        <div ref={ref} className={styles.wrapper}>
            <div className={styles.groups}>
                {activeMainFacetID &&
                    <MiddlefacetsContainer/>
                }

                {activeMainFacetID &&
                    <GroupsContainer/>
                }
            </div>

            {!isMobile &&
                <div className={styles.facets}>
                    {/* On desktop the menu has 2 columns: The groups are on the left the facets on the right. */}
                    {/* On mobile the facets are expected to be rendered right below the group they belong to. */}
                    <FacetsContainer/>
                </div>
            }

            <SubmitFilterButtonContainer />
        </div>
    );
};

export default MenuContainer;
